import { render, staticRenderFns } from "./MemberDetailsCard.vue?vue&type=template&id=1b8267ba&scoped=true"
import script from "./MemberDetailsCard.vue?vue&type=script&lang=js"
export * from "./MemberDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./MemberDetailsCard.vue?vue&type=style&index=0&id=1b8267ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8267ba",
  null
  
)

export default component.exports